<div class="slim-scroll thin h-100 cs-sidebar-nav cs-sidebar-theme-{{themeName}}">
    <div class="aside-container panel-wrapper h-100">
        <div class="progress-panel height-with-top-menu h-100">
            <div class="overall-progress" *ngIf="showProgressBar">
                <div class="progress-head">
                    <div class="progress-text" translate>Con.Total.Progress</div>
                    <div class="progress-percent">{{totalProgress}}%</div>
                </div>
                <div class="overall-progress-bar">
                    <div class="percent-bar" [style.width]="totalProgress + '%'"></div>
                </div>
            </div>

            <div class="steps-container steps-{{themeName}}" [appCsScrollbar]>
                <ng-container *ngIf="themeName == 'stepper'">
                    <div class="step" *ngFor="let item of menuItems; let i = index" [ngClass]="{'active-step': item?.selected === true}">
                        <div class="step-wrap" [ngClass]="{' not-allowed': item.status === 'pending'}" (click)="menuItemClick(i, undefined)">
                            <div class="left-content">
                                <div class="stage" id="{{item.id}}"> {{ stepHeader }} {{ i + 1 }}</div>
                                <div class="step-text"> {{ item.title }} </div>
                            </div>
                            <div class="right-content">
                                <div class="step-completed-status" [ngClass]="{'active-border': item.status === 'in_progress' || item.status === 'completed' }"
                               >
                                    <svg class="progress-status" width="36px" height="36px" *ngIf="item.status === 'completed'">
                                        <circle
                                            class="progress-circle"
                                            cx="18"
                                            cy="18"
                                            r="16px"
                                            stroke="#4A90E2"
                                            stroke-width="3px"
                                            stroke-dasharray=100
                                            stroke-linecap="round"
                                            [style.stroke-dashoffset]="0"
                                            [ngStyle]="{'fill': item.status == 'completed' ? '#4A90E2' : 'none'}">
                                        </circle>
                                    </svg>
                                    <div class="complete" *ngIf="item.status == 'completed'">
                                        <div class="complete-icon"></div>
                                    </div>
                                    <div class="active-icon-wrapper" *ngIf="item.status == 'in_progress'">
                                        <div class="active-icon active-border"></div>
                                    </div>
                                    <div class="active-icon-wrapper" *ngIf="item.status == 'pending'">
                                        <div class="active-icon"></div>
                                    </div>
                                </div>

                                <ng-template #info_icon>
                                    <div class="indication-icon-wrapper">
                                        <div class="info-icon-content">
                                            <div class="info-icon-wrapper" tooltip="This step has been disabled" placement="top" container="body">
                                                <div class="info-icon">
                                                    <div class="element rounded"></div>
                                                    <div class="element line"></div>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </ng-template>

                            </div>
                        </div>
                    </div>
                </ng-container>

                <ng-container *ngIf="themeName == 'default'">
                    <div class="step" *ngFor="let group of navService.groups; let i = index">
                        <div class="step-wrap">
                            <div class="left-content">
                                <div class="step-header m-b--10"> {{ group.title }} </div>
                            </div>
                        </div>
                        <div class="step"
                             *ngFor="let menu of navService.menuItemsGroup[group.id]; let i = index"
                             [ngClass]="{'active-step': menu?.selected === true}">
                            <div class="step-wrap" (click)="menuItemClick(i, group.id)">
                                <span class="m-r--10" *ngIf="menu.iconClass">
                                    <i class="{{menu.iconClass}}"></i>
                                </span>
                                <div class="left-content">
                                    <div class="step-text"> {{ menu.title }} </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </ng-container>

            </div>
        </div>
    </div>
</div>
